import { Breadcrumb } from "@refinedev/antd";
import styled from "styled-components";
import { useBreadcrumb } from "@refinedev/core";

export const Breadcrumbs = ({
  size,
  color,
}: {
  size?: "md" | "lg";
  color?: string;
}) => {
  const { breadcrumbs } = useBreadcrumb();

  const fontSize = {
    md: "14px",
    lg: "22px",
  };

  // Use different breadcrumbs based on the current route
  const breadcrumbSize = breadcrumbs.some(
    (crumb) => crumb?.label === "Show" || crumb.label === "Montrer"
  )
    ? "md"
    : "lg";

  return (
    <StyledContainer
      $textSize={fontSize[size ?? breadcrumbSize]}
      $color={color}
      $fontWeight={size === "md" ? "300" : undefined}
    >
      <Breadcrumb hideIcons />
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{
  $textSize: string;
  $color?: string;
  $fontWeight?: string;
}>`
  .ant-breadcrumb {
    font-size: ${(props) => props.$textSize} !important;
    font-weight: ${(props) => props.$fontWeight} !important;
    a {
      height: 100%;
    }
    ${(props) =>
      props.$color &&
      `
      color: ${props.$color} !important;
      a, .ant-breadcrumb-link, .ant-breadcrumb-separator {
        color: ${props.$color} !important;
      }
    `}
  }
`;
